import { motion } from "framer-motion";
import { Sparkles, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/LanguageContext";

const NoListSection = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-white/[0.02] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="glass-card rounded-2xl p-10 text-center max-w-3xl mx-auto"
        >
          <div className="w-16 h-16 rounded-2xl bg-yellow-400/10 flex items-center justify-center mx-auto mb-6">
            <Sparkles className="w-8 h-8 text-yellow-400" />
          </div>
          <h2
            className="text-2xl sm:text-3xl font-black text-white mb-4"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            {t("noList.title")}
          </h2>
          <p className="text-white/60 mb-8 max-w-xl mx-auto">
            {t("noList.desc")}
          </p>
          <Button className="btn-accent rounded-xl px-8 py-6 font-bold text-base">
            <Zap className="w-5 h-5 mr-2" />
            {t("noList.button")}
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default NoListSection;
